import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'provider/src/module/auth/auth-context.ts';

export function AuthProtection(props: { children: ReactNode }) {
  const { auth } = useAuth();

  if (auth) {
    return <>{props.children}</>;
  } else {
    return <Navigate to="login" />;
  }
}
